import { Button, Spinner } from "react-bootstrap";
import "./SpinnerButton.css";

import PropTypes from "prop-types";

function SpinnerButton({ text, action, variant, waiting, disabled }) {
  const searchButtonTextVisibility = waiting ? "hidden" : "visible";
  const searchSpinnerVisibility = waiting ? "visible" : "hidden";

  return (
    <div className="spinner-button-container">
      <Button
        className="spinner-button"
        disabled={disabled}
        variant={variant}
        onClick={(e) => (waiting ? e.preventDefault() : action())}
      >
        <div
          className="spinner-button-text"
          style={{ visibility: searchButtonTextVisibility }}
        >
          {text}
        </div>
        <Spinner
          className="spinner-button-spinner"
          size="sm"
          animation="border"
          role="status"
          style={{ visibility: searchSpinnerVisibility }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Button>
    </div>
  );
}

SpinnerButton.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
  waiting: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

SpinnerButton.defaultProps = {
  disabled: false,
};

export default SpinnerButton;
